import { z } from "zod";

export const userAddressModalSchema = z.object({
  addressId: z.string().min(1, "Please select an address"),
});

export type UserAddressFormData = z.infer<typeof userAddressModalSchema>;
